export var AfriexBlockReason;
(function (AfriexBlockReason) {
    AfriexBlockReason["SANCTIONS_MATCH"] = "SANCTIONS_MATCH";
    AfriexBlockReason["IDENTITY_THEFT"] = "IDENTITY_THEFT";
    AfriexBlockReason["SOCIAL_ENGINEERING"] = "SOCIAL_ENGINEERING";
    AfriexBlockReason["MULTIPLE_DISPUTES"] = "MULTIPLE_DISPUTES";
    AfriexBlockReason["OTHERS"] = "OTHERS";
    AfriexBlockReason["POSITIVE_DOW_JONES_MATCH"] = "POSITIVE_DOW_JONES_MATCH";
    AfriexBlockReason["CONFIRMED_FRAUDULENT_ACTIVITY"] = "CONFIRMED_FRAUDULENT_ACTIVITY";
    AfriexBlockReason["FRAUDULENT_ACTIVITY_INVESTIGATION_ONGOING"] = "FRAUDULENT_ACTIVITY_INVESTIGATION_ONGOING";
    AfriexBlockReason["ACCOUNT_TAKEOVER_CASE"] = "ACCOUNT_TAKEOVER_CASE";
    AfriexBlockReason["UNAUTHORIZED_TRANSACTIONS_INVESTIGATION_COMPLETED"] = "UNAUTHORIZED_TRANSACTIONS_INVESTIGATION_COMPLETED";
    AfriexBlockReason["IDENTITY_THEFT_CASE"] = "IDENTITY_THEFT_CASE";
    AfriexBlockReason["ACH_FRAUD"] = "ACH_FRAUD";
    AfriexBlockReason["DO_NOT_ISSUE_VIRTUAL_ACCOUNT"] = "DO_NOT_ISSUE_VIRTUAL_ACCOUNT";
})(AfriexBlockReason || (AfriexBlockReason = {}));
//# sourceMappingURL=AfriexBlockReason.js.map